var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"20","cy":"20","r":"18.5","fill":"white","stroke":"black","strokeWidth":"3","key":0}),React.createElement("g",{"clipPath":"url(#clip0_1511_95198)","key":1},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M28.9082 13.6364H10.9082V16.6364H28.9082V13.6364ZM28.9082 22.6364H10.9082V25.6364H28.9082V22.6364Z","fill":"black"})),React.createElement("defs",{"key":2},React.createElement("clipPath",{"id":"clip0_1511_95198"},React.createElement("rect",{"width":"18.1818","height":"11.8182","fill":"white","transform":"translate(10.9082 13.6364)"})))]);
}

Menu.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = Menu;

Menu.default = Menu;
